const IS_LOCAL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE = IS_LOCAL
  ? 'http://localhost:8787' : 'https://pwd-api.adam-hoemberg.workers.dev';

export const AUTH_API_BASE = IS_LOCAL
  ? API_BASE
  : 'https://cxjbuevhijweijyoowvg.supabase.co/functions/v1/driver-auth-cutover';

function resolveBase(path: string): string {
  if (path === '/api/auth/validate' || path === '/api/auth/login' || path === '/api/driver/home') return AUTH_API_BASE;
  return API_BASE;
}

export function getToken(): string | null { return localStorage.getItem('pwd_driver_token'); }
export function setToken(t: string): void { localStorage.setItem('pwd_driver_token', t); }
export function clearToken(): void { localStorage.removeItem('pwd_driver_token'); localStorage.removeItem('pwd_driver_employee'); }

export async function api<T = unknown>(path: string, opts?: RequestInit): Promise<T> {
  const token = getToken();
  const res = await fetch(resolveBase(path) + path, {
    ...opts,
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token, ...(opts?.headers || {}) },
  });
  return res.json() as Promise<T>;
}

export async function apiPost<T = unknown>(path: string, body: unknown): Promise<T> {
  return api<T>(path, { method: 'POST', body: JSON.stringify(body) });
}
